import LabelCard from "./LabelCard";
import { LabelData } from "../../StaticData/LabelData";
import "./Label.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

export interface ILabelListProps {
  width: number;
}

export default function LabelList({ width }: ILabelListProps) {
  return (
    <div className="label_container">
      <div className="label_title">
        <div className="blue_line"></div>
        <h2 className="h2_huge">OUR LABELS</h2>
      </div>
      <div className="label_elements_container">
        {LabelData.map((label, i) => (
          <LabelCard label={label} key={i} />
        ))}
      </div>
      {width <= 1780 && (
        <div className="d-flex justify-content-center align-items-center">
          <FontAwesomeIcon
            icon={faArrowLeft}
            className="mx-4"
            style={{ opacity: 0.5 }}
          />
          <FontAwesomeIcon
            icon={faArrowRight}
            className="mx-4"
            style={{ opacity: 0.5 }}
          />
        </div>
      )}
    </div>
  );
}
